import React, { useContext, useEffect, useState } from 'react'
import './footer.scss'
import H5 from '../Fonts/H5/H5'
import P from '../Fonts/P/P'
import A from '../Fonts/A/A'
import { Fetcher } from '../../helpers/api/Fetcher'
import { language } from '../../App'
import { Col, Container, Row } from 'react-bootstrap'
import { getPrefix } from '../../helpers/prefixHelper'

const Footer = () => {
  const { currentLanguage } = useContext(language)
  const prefix = getPrefix(currentLanguage)
  const [isLoading, setIsLoading] = useState(false)
  const [data, setData] = useState([])

  useEffect(() => {
    const fecthApi = async () => {
      const URL = `https://beta.haromstudio.hu/scriptedprod/wp-json/wp/v2/pages/${currentLanguage==='hu'? 42 : 44}?_embed&acf_format=standard`;
      const res = await Fetcher({ URL, setIsLoading })
      setData(res)

      setIsLoading(false)
    }

    fecthApi()
  }, [currentLanguage])


  return (
    <div className='footer'>
      <Container>
        <Row className='mt-4'>
          <Col xs={12}>
            {!isLoading && data.acf &&
            <div className='block d-flex m-flex-column flex-row justify-content-between align-items-center p-4'>
              <div>
                <H5 text={data.acf.footer_cegnev} bold={true}/>
                <H5 text={data.acf.footer_cim} />
              </div>
              <div>
                <div dangerouslySetInnerHTML={{ __html: data.acf.footer_text_1 }}></div>
              </div>
              <div>
                <div dangerouslySetInnerHTML={{ __html: data.acf.footer_text_2 }}></div>
              </div>
            </div>}
          </Col>  
        </Row>
      </Container>

      <Container>
        <Row className='mt-4 pb-4'>
          <Col xs={12}>
            <div id='copyright' className='block block-black d-flex flex-row m-flex-column justify-content-between align-items-center'>
              <P text={currentLanguage === 'hu' ? 'Copyright © 2024 Scripted Productions. Minden jog fenntartva.' : 'Copyright © 2024 Scripted Productions. All rights reserved.'} />
              <A title={currentLanguage === 'hu' ? 'Adatvédelem' : 'Adatvédelem'}
                url={`${prefix}/adatvedelem`}
                classes='text-white' />
            </div>
          </Col>  
        </Row>
      </Container>
    </div> 
  )
}

export default Footer;